import { atom } from "recoil"

import type { UserDataIF } from "interfaces/UserDataIF"

export const firebaseUserState = atom<UserDataIF>({
  key: "firebaseUser",
  default: {
    uid: null,
    email: null,
    emailVerified: false,
    isAuth: false,
    isFirebaseInitialized: false,
  },
})
